<script lang='ts'>
import { reactive, defineComponent, computed } from '@vue/composition-api';

import * as currentUserStoreModule from '@/store/global/currentUser';

interface IProps {
    dismissKey: string;
    text: string;
}

const AppQuickTip = defineComponent({
    name: 'AppQuickTip',
    props: {
      dismissKey: String,
      text: String, 
    },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const store = currentUserStoreModule.useCurrentUserModule();
        
        const state = reactive({
          shouldShow: computed(() => !store.state.dismissedQuickTipKeys.includes(props.dismissKey)),
        })

        const onDismiss = async () => {
          await store.dispatch(new currentUserStoreModule.DismissQuickTip(props.dismissKey));
        }

        return {
            state,

            onDismiss
        };
    }
});

export default AppQuickTip;
</script>

<template>
  <div v-if="state.shouldShow" class="board-quick-tip d-flex align-center" @click="onDismiss">
    <span class="board-quick-tip__bulb mr-2" />
    <span>{{ text }}</span>
  </div>
</template>

<style lang='scss' scoped>

.board-quick-tip {
    position: fixed;
    right: 110px;
    bottom: 110px;
    z-index: 100;
    padding: 8px;
    background: #fff;
    color: var(--v-cardListColor-base);
    border: 1px solid  var(--v-cardListColor-base);
    border-radius: 4px;
    font-weight: 700;
    cursor: pointer;
    margin-left: 20px;
    transition: none;
    transform: translateY(70px);

    &.visible {
        transform: translateY(0);
        transition: transform 1.5s ease-in-out;
    }
}

.board-quick-tip__bulb {

    &:before {
        content: '\1F4A1';
        animation: bulb-moving 1s infinite;
        animation-timing-function: linear;
        display: inline-block;
        font-weight: 400;
    }
}

@keyframes bulb-moving {
    0% {
        transform: scale(1);
    }

    25% {
        transform: scale(1.25);
    }


    75% {
        transform: scale(0.8);
    }

    100% {
        transform: scale(1);
    }
}
</style>